<mat-sidenav-container class="dskhome-sidenav-container">

  <mat-sidenav #snav mode="over" (opened)="platformDataService.documentRef.body.classList.add('overflow-hidden')"
    (closed)="platformDataService.documentRef.body.classList.remove('overflow-hidden')">
    <div class="header">
      <a class="logo" #anchorEl routerLink="/home" [replaceUrl]="isMortgageApplicationPath()" aria-label="Начало"
        i18n-aria-label>
        <mat-icon svgIcon="dskhome-logo" />
      </a>
      <button matIconButton class="drawer-toggle" (click)="snav.toggle()" aria-label="Отвори меню" i18n-aria-label>
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <mat-nav-list class="sidenav-menu dskhome-nav-list hide-scrollbar">
      <!-- Regular Link -->
      <a mat-list-item class="list-item-small-padding" routerLink="/listings/search"
        [replaceUrl]="isMortgageApplicationPath()" routerLinkActive="is-active" aria-label="Намери имот"
        i18n-aria-label>
        <mat-icon svgIcon="otp-search-house" class="list-item-leading-icon icon-with-green-highlight"></mat-icon>
        <span i18n>Намери имот</span>
      </a>
      <!--    TODO: Activate when the pages are ready-->
      <!-- <a mat-list-item class="list-item-small-padding" routerLink="/credit-requests" [replaceUrl]="isMortgageApplicationPath()" routerLinkActive="is-active"
        aria-label="Продай имот" i18n-aria-label>
        <mat-icon svgIcon="otp-home-own" class="list-item-leading-icon icon-with-green-highlight"></mat-icon>
        <span i18n>Продай имот</span>
      </a> -->
      <a mat-list-item class="list-item-small-padding" routerLink="/mortgage-application"
        [replaceUrl]="isMortgageApplicationPath()" routerLinkActive="is-active" aria-label="Кандидатствай за кредит"
        i18n-aria-label>
        <mat-icon svgIcon="otp-money-document" class="list-item-leading-icon icon-with-green-highlight"></mat-icon>
        <span i18n>Кандидатствай за кредит</span>
      </a>

      <!-- Link with submenu -->
      <mat-action-list>
        <button mat-list-item class="list-item-small-padding" (click)="toggleSubMenu()"
          [class.is-active]="isPurchaseSubmenuRouteActive()" aria-label="Планирай покупка" i18n-aria-label>
          <mat-icon svgIcon="otp-home-star" class="list-item-leading-icon icon-with-green-highlight"></mat-icon>
          <span i18n>Планирай покупка</span>
          <mat-icon svgIcon="otp-arrow-down" [class.expanded]="isSubmenuOpen()"
            class="list-item__submenu-icon"></mat-icon>
        </button>
      </mat-action-list>

      <!-- Submenu options (shown conditionally) -->
      @if(isSubmenuOpen()) {
      <mat-nav-list class="dskhome-nav-list nav-list__submenu-level--1">
        <!--    TODO: Activate when the pages are ready-->
        <!-- <a mat-list-item routerLink="/home" [replaceUrl]="isMortgageApplicationPath()" routerLinkActive="is-active" i18n>Видове ипотечни кредити</a>
        <a mat-list-item routerLink="/calculator/form" [replaceUrl]="isMortgageApplicationPath()" routerLinkActive="is-active" i18n>Ипотечни калкулатори</a>
        <a mat-list-item routerLink="/calculator/results" [replaceUrl]="isMortgageApplicationPath()" routerLinkActive="is-active" i18n>Как да взема ипотека</a> -->
        <!-- <a mat-list-item routerLink="/insurances" [replaceUrl]="isMortgageApplicationPath()" routerLinkActive="is-active" i18n>Застраховки</a> -->
        <a mat-list-item routerLink="/property-appraisal" [replaceUrl]="isMortgageApplicationPath()"
          routerLinkActive="is-active" i18n>Автоматизирана пазарна
          оценка</a>
        <!-- <a mat-list-item routerLink="/market-analysis" [replaceUrl]="isMortgageApplicationPath()" routerLinkActive="is-active" i18n>Анализ на имотния пазар</a> -->
      </mat-nav-list>
      }
    </mat-nav-list>

    <a routerLink="/schedule-appointment" [replaceUrl]="isMortgageApplicationPath()" matButton="filled"
      class="otp-button schedule-appointment-button" data-otp-color="orange" i18n>
      Ипотечна консултация
    </a>
  </mat-sidenav>

  <mat-sidenav-content>
    <dskhome-menu [snav]="snav" [isPurchaseSubmenuRouteActive]="isPurchaseSubmenuRouteActive()" />

    <main class="main">
      <ng-content />
    </main>

    <dskhome-footer />

    <!-- Elements outside the flow (absolute, fixed, etc.) -->
    <button matFab class="otp-button cookie-consent__icon-button"
      aria-label="Управление на предпочитанията за бисквитки" i18n-aria-label (click)="openCookieSettings()">
      <mat-icon svgIcon="cookie-consent-icon" class="cookie-consent__icon"></mat-icon>
    </button>

    <!-- TODO: wait changes from cloud team whitelist the domain -->
    <!-- <button matFab class="otp-button ai-chat__button" aria-label="Отвори чат асистент" i18n-aria-label
      (click)="openAiChat()">
      <mat-icon svgIcon="otp-chat" class="ai-chat__icon"></mat-icon>
    </button> -->
  </mat-sidenav-content>
</mat-sidenav-container>